export const addDays = (date: Date, days: number): Date => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};
export const startOfWeek = (date: Date, weekStartsOnMonday = true): Date => {
  const day = date.getDay();
  const diff = weekStartsOnMonday ? (day + 6) % 7 : day;
  return addDays(new Date(date.getFullYear(), date.getMonth(), date.getDate()), -diff);
};
export const endOfWeek = (date: Date, weekStartsOnMonday = true): Date => {
  return addDays(startOfWeek(date, weekStartsOnMonday), 6);
};
export const startOfDayISO = (date: Date): string => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

export const formatDateFriendly = (date: Date): string => {
  return date.toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric' });
};

export const formatRange = (start: Date, end: Date): string => {
  const s = start.toLocaleString('default', { month: 'short', day: 'numeric' });
  const e = end.toLocaleString('default', { month: 'short', day: 'numeric', year: 'numeric' });
  return `${s} — ${e}`;
};
